import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { WorkerManagerOptions } from '@/modules/core/app/models/WorkerManagerOptions';
import { WorkerManagerError } from '@/modules/core/app/models/WorkerManagerError';
import { WorkerManagerJobStatus } from '@/modules/core/app/constants/workermanager.constants';

export class WorkerManager extends BaseModel {
  /**
   * @var {string}
   */
  status;

  /**
   * @var {string}
   */
  job_id;

  /**
   * @var {object}
   */
  output;

  /**
   * @var {string}
   */
  error;

  /**
   *@var {WorkerManagerOptions}
   */
  options;

  constructor(model = {}) {
    super(model);
    this.status = model.status;
    this.job_id = model.job_id;
    this.output = model.output;
    this.error = model.error;
    this.options = WorkerManagerOptions.factory(model.options);
  }

  isLoading() {
    return this.status === WorkerManagerJobStatus.LOADING;
  }

  isError() {
    return this.status === WorkerManagerJobStatus.ERROR;
  }

  isSuccess() {
    return this.status === WorkerManagerJobStatus.SUCCESS;
  }

  getOutput() {
    return this.output;
  }

  getError() {
    return new WorkerManagerError(this.error);
  }
}
